module.exports = __webpack_public_path__ + "static/media/Hospitalização.c527309b.svg";